
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const MentionsLegalesPage = () => {
  return (
    <>
      <header>
        <h1 className="sr-only">Mentions légales - SARL ADF Biomédical Algérie</h1>
      </header>
      <Navbar />
      <main>
        {/* HERO SECTION */}
        <section className="relative pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <p className="text-sm text-text-secondary mb-6">
                <Link to="/" className="hover:text-[#E31B23] transition-colors cursor-pointer">Accueil</Link> / Mentions légales
              </p>
              <h2 className="text-5xl md:text-6xl font-bold text-text-primary mb-6">
                Mentions légales
              </h2>
              <p className="text-xl text-text-secondary max-w-3xl mx-auto">
                Informations légales relatives à SARL ADF Biomédical
              </p>
            </motion.div>
          </div>
        </section>

        {/* CONTENU LÉGAL */}
        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="space-y-12"
            >
              {/* Identification de l'entreprise */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-building-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Identification de l'entreprise
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Raison sociale :</strong> SARL ADF Biomédical
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Forme juridique :</strong> Société à Responsabilité Limitée (SARL)
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Capital social :</strong> 10 000 000 DZD
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Année de création :</strong> 2013
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Siège social :</strong> Local N01 Benghazi N16, Baraki, Alger, Algérie
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Téléphone :</strong> +213 770 30 79 05
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Email :</strong> contact@adfbiomedical.dz
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Activité :</strong> Établissement pharmaceutique spécialisé dans l'importation, la fabrication et la distribution de dispositifs médicaux
                  </p>
                </div>
              </div>

              {/* Directeur de publication */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-user-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Directeur de publication
                </h3>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Le directeur de la publication du site adfbiomedical.dz est le représentant légal de la SARL ADF Biomédical.
                  </p>
                </div>
              </div>

              {/* Hébergement du site */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-server-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Hébergement du site
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Hébergeur :</strong> Readdy.ai
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Site web :</strong> <a href="https://readdy.ai" target="_blank" rel="noopener noreferrer" className="text-[#E31B23] hover:underline cursor-pointer">https://readdy.ai</a>
                  </p>
                </div>
              </div>

              {/* Propriété intellectuelle */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-copyright-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Propriété intellectuelle
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    L'ensemble du contenu de ce site (textes, images, logos, graphismes, vidéos, etc.) est la propriété exclusive de SARL ADF Biomédical ou de ses partenaires, et est protégé par les lois algériennes et internationales relatives à la propriété intellectuelle.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de SARL ADF Biomédical.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de la Propriété Intellectuelle français et des lois algériennes en vigueur.
                  </p>
                </div>
              </div>

              {/* Limitation de responsabilité */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-shield-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Limitation de responsabilité
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site, dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Toutefois, SARL ADF Biomédical ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    En conséquence, SARL ADF Biomédical décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l'utilisateur, lors de l'accès au site, et résultant soit de l'utilisation d'un matériel ne répondant pas aux spécifications indiquées, soit de l'apparition d'un bug ou d'une incompatibilité.
                  </p>
                </div>
              </div>

              {/* Liens hypertextes */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-links-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Liens hypertextes
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Le site peut contenir des liens hypertextes vers d'autres sites présents sur le réseau Internet. Les liens vers ces autres ressources vous font quitter le site adfbiomedical.dz.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Il est possible de créer un lien vers la page de présentation de ce site sans autorisation expresse de SARL ADF Biomédical. Aucune autorisation ou demande d'information préalable ne peut être exigée par l'éditeur à l'égard d'un site qui souhaite établir un lien vers le site de l'éditeur. Il convient toutefois d'afficher ce site dans une nouvelle fenêtre du navigateur.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Cependant, SARL ADF Biomédical se réserve le droit de demander la suppression d'un lien qu'elle estime non conforme à l'objet du site.
                  </p>
                </div>
              </div>

              {/* Droit applicable */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-scales-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Droit applicable et juridiction compétente
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Les présentes mentions légales sont régies par le droit algérien. Tout litige relatif à l'utilisation du site adfbiomedical.dz est soumis à la compétence exclusive des tribunaux algériens.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    En cas de litige, les parties s'efforceront de trouver une solution amiable avant toute action judiciaire.
                  </p>
                </div>
              </div>

              {/* Contact */}
              <div className="bg-gradient-to-r from-[#E31B23] to-[#C41820] rounded-2xl p-12 text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-white/20 rounded-full">
                  <i className="ri-mail-line text-5xl text-white"></i>
                </div>
                <h4 className="text-3xl font-bold text-white mb-4">Des questions ?</h4>
                <p className="text-lg text-white/90 mb-8">
                  Pour toute question concernant ces mentions légales, contactez-nous
                </p>
                <Link
                  to="/contact"
                  className="inline-block px-10 py-4 bg-white text-[#E31B23] rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
                >
                  Nous contacter
                </Link>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default MentionsLegalesPage;
